<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Expense Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "index",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Expense Item",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
      ],
      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapGetters("expenses", ["ExpenseDetail", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    rows() {
      return this.ExpenseDetail ? this.ExpenseDetail.items.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ExpenseDetail ? this.ExpenseDetail.items.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpense: "expenses/fetchExpense",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.ExpenseDetail ? this.ExpenseDetail.items.length : 1;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchExpense(this.id);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_expenses')
        )
      "
    >
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title text-primary">List of Expense Items</h3>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ExpenseDetail ? ExpenseDetail.items : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9"><h3>Expense Details</h3></div>
              <div class="col-md-3">
                <router-link to="/expenses/view" class="btn btn-success btn-sm"
                  >Expenses</router-link
                >
              </div>
            </div>
            <div class="form-group mb-3">
              <label
                >Total Amount:
                {{ ExpenseDetail ? ExpenseDetail.amount : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Amount Paid:
                {{ ExpenseDetail ? ExpenseDetail.paid : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Expense Date:
                {{ ExpenseDetail ? ExpenseDetail.expdate : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Payment Method:
                {{ ExpenseDetail ? ExpenseDetail.mode : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Supplier:
                {{ ExpenseDetail ? ExpenseDetail.supplier : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Recorded On:
                {{ ExpenseDetail ? ExpenseDetail.addedon : "" }}</label
              >
              <hr />
            </div>
            <div class="form-group mb-3">
              <label
                >Recorded By:
                {{ ExpenseDetail ? ExpenseDetail.user : "" }}</label
              >
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
